module.exports = {"321281001":"昭阳街道","321281002":"临城街道","321281003":"垛田街道","321281100":"戴窑镇","321281101":"合陈镇","321281102":"永丰镇","321281103":"新垛镇","321281104":"安丰镇","321281105":"海南镇","321281106":"钓鱼镇","321281107":"大邹镇","321281108":"沙沟镇","321281109":"中堡镇","321281114":"竹泓镇","321281115":"沈伦镇","321281116":"大垛镇","321281117":"荻垛镇","321281118":"陶庄镇","321281119":"昌荣镇","321281121":"周庄镇","321281122":"陈堡镇","321281123":"戴南镇","321281126":"大营镇","321281129":"兴东镇","321281130":"千垛镇","321281204":"林湖乡","321281400":"开发区","321281401":"良种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321281.json
// module id = 1032
// module chunks = 0